/*eslint-disable */
import React, { Component } from "react";
import { Table, Icon, Button, Header } from "semantic-ui-react";
import ModalEditJobOrder from "./modalEditOrder";
import ReadAxios from "../axiosComponent/read";
import { connect } from "react-redux";
import { deleteOrderDispatcher, createShipmentDispatcher } from "../../redux/actions/shipmentAction";
import { translate } from "react-i18next";
import { warningAlertDispatcher } from "../../redux/actions/alertAction";
import {VehicleType} from "../shipmentComponent/vehicleType";

export class InsertEditOrder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openModel: false,
      deleteModal: false,
      firstSubmitCall: false,
      editOrderData: {},
      editOrderIndex: null,
      currentShipment: {},
      vehicleType: [],
    };
  }

  checkValue = (key) => {
    return this.props.values[key] ? true : false;
  };

  // componentDidMount() {
  //   if (this.props.mode == "edit") {
  //     ReadAxios({
  //       completeURL: `${process.env.REACT_APP_TA_API_URL}shipments/${this.props.shipment.create.vendor_shipment_id}/orders`,
  //     }).then((res) => {
  //       console.log('orders by shipment id',res.data.order)
  //       // let newOrder = res.data.order;
  //       // let tempShipment = this.props.shipment;
  //       // let newTempShipment = tempShipment.create.orders[index] = newOrder;
  //       // this.props.createShipment(tempShipment.create, false);
  //       // this.setState({
  //       //   openModel: true,
  //       //   editOrderData: tempShipment.create.orders[index],
  //       //   editOrderIndex: index,
  //       // });
  //     });
  //   }
  // }

  checkFormIsValid = () => {
    return (
      // this.checkValue("shipment_reference_no") &&
      this.checkValue("required_on") &&
      this.checkValue("route_code") &&
      // this.checkValue("proposed_vehicle_type") &&
      this.checkValue("source") &&
      this.checkValue("destination") &&
      this.checkValue("no_of_vehicles") &&
      this.checkValue("movement_type") 
      //&& this.checkValue("base_rate")
    );
  };

  // TODO: update validation logic
  doMainShipmentFormValidation = () => {
    let isCreateObj = this.props.shipment && this.props.shipment.create;
    if (isCreateObj) {
      if (this.checkFormIsValid()) {
        console.log("form is valid");
        // form is valid
        if (!this.state.firstSubmitCall) {
          console.log("first time call made");
          this.setState({ openModel: true, firstSubmitCall: true }, () =>
            this.props.handleSubmit()
          );
        } else {
          console.log("not first time call");
          if (this.props.values.movement_type == "primary") {
            if (
              this.props.shipment.create.orders &&
              this.props.shipment.create.orders.length > 0 &&
              this.props.shipment.create.no_of_vehicles <= this.props.shipment.create.orders.length
            ) {
              // open modal to disacard prev orders
              console.log("delet modal open");
              this.setState({ deleteModal: true });
            } else {
              console.log("left with more vehicle");
              this.setState({ openModel: true, firstSubmitCall: true });
            }
          } else {
            this.setState({ openModel: true, firstSubmitCall: true });
          }
          
        }
      } else {
        console.log("form is not valid");
        this.props.handleSubmit();
      }
    } else {
      console.log("create obj not found");
      if (this.checkFormIsValid()) {
        console.log(" not create form is valid");
        if (!this.state.firstSubmitCall) {
          console.log("not create first call made");
          this.setState({ openModel: true, firstSubmitCall: true }, () =>
            this.props.handleSubmit()
          );
        } else {
          console.log("not create not first call");
          this.setState({ openModel: true }, () => this.props.handleSubmit());
        }
      } else {
        console.log("not create form invalid");
        this.props.handleSubmit();
      }
    }
  };

  handleModelOpen = () => {
    if (this.props.shipment.create.orders) {
      if (this.props.values.movement_type == "primary") {
        if (
          this.props.shipment.create.orders.length <
          this.props.values.no_of_vehicles 
        ) {
          this.doMainShipmentFormValidation();
        } else {
          let alert = {
            type: "warning",
            messageHeader: "Warning",
            messageBody: "Can not create more orders then required vehicle.",
          };
          this.props.warning(alert);
        }
      } else {
        this.doMainShipmentFormValidation();
      }
    } else {
      this.doMainShipmentFormValidation();
    }
    // this.setState({ openModel: true });
  };

  handleModelClose = () => {
    this.setState({
      openModel: false,
      editOrderData: {},
      editOrderIndex: null,
    });
  };

  // getVehicle = async () => {
  //   console.log('orders', this.props.shipment.create.orders);
  //   let dataArray =
  //     (await ReadAxios({
  //       url: `vehicleTypeMaster/${this.props.shipment.create.orders}`,
  //     })) || [];
  //   dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
  //   this.setState({ vehicleType: dataArray || [] });
  //   console.log('v', this.state.vehicleType);
  // }

  deleteOrder = (order, index) => {
    this.props.deleteOrder(index);
  };

  editOrder = (order, index) => {
    // if (this.props.mode == "edit") {
    //   if (order.deliveries) {
    //     this.setState({
    //       openModel: true,
    //       editOrderData: order,
    //       editOrderIndex: index,
    //     });
    //   } else {
    //     ReadAxios({
    //       completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${order.vendor_order_id}`,
    //     }).then((res) => {
    //       console.log(res.data.order)
    //       let newOrder = res.data.order;
    //       let tempShipment = this.props.shipment;
    //       let newTempShipment = tempShipment.create.orders[index] = newOrder;
    //       this.props.createShipment(tempShipment.create, false);
    //       this.setState({
    //         openModel: true,
    //         editOrderData: tempShipment.create.orders[index],
    //         editOrderIndex: index,
    //       });
    //     });
    //   }
    // } else {
      console.log('in else');
      this.setState({
        openModel: true,
        editOrderData: order,
        editOrderIndex: index,
      });
    // }
    
      console.log('editdata>>>', this.state.editOrderData);
    // if (props.currenOrder.proposed_vehicle_type) {
    //   console.log('component is called');
    //   getVehicleType(props.currenOrder.proposed_vehicle_type);
    // }
  };

  render() {
    const { t } = this.props;
    const { vehicleType } = this.state;
    return (
      <React.Fragment>
        <Table stackable selectable size="small">
          <Table.Header className="w3-small">
            <Table.Row>
              <Table.HeaderCell colSpan="4">
                <Header
                  as="label"
                  size="tiny"
                  color="black"
                  className="labelName p-bold-500"
                >
                  {"Order Details edit"}
                </Header>
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="right">
                <Button
                  primary
                  onClick={this.handleModelOpen}
                  size="mini"
                  type="button"
                >
                  <Icon name="plus" /> {t("action_button.new") || "New"}
                </Button>
              </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              {/* <Table.HeaderCell className="p-bold-600">
                {t("table_header.order_no") || "Order No"}
              </Table.HeaderCell> */}
              <Table.HeaderCell className="p-bold-600">
                {t("table_header.reference_no") || "Reference No"}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-600">
                {t("table_header.gross_weight") || "Gross Weight"}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-600">
                {t("table_header.propose_vehicle_type") || "Proposed Vehicle Type"}
              </Table.HeaderCell>
              {/* <Table.HeaderCell className="p-bold-600">Status</Table.HeaderCell> */}
              <Table.HeaderCell className="p-bold-600">
                {t("table_header.edit") || "Edit"}
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="right" className="p-bold-600">
                {t("table_header.delete") || "Delete"}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.props.shipment &&
            this.props.shipment.create &&
            this.props.shipment.create.orders &&
            this.props.shipment.create.orders.length > 0 ? (
              <>
                {this.props.shipment.create.orders.map((order, index) => (
                  <Table.Row key={index}>
                    {/* <Table.Cell>{order.order_number}</Table.Cell> */}
                    <Table.Cell>{order.order_reference_no}</Table.Cell>
                    <Table.Cell>{order.gross_weight}</Table.Cell>
                    <Table.Cell>
                      <VehicleType
                            proposedVehicleType={order.proposed_vehicle_type}
                            // movementType={item.movement_type}
                          /></Table.Cell>
                    {/* <Table.Cell>{"NA"}</Table.Cell> */}
                    <Table.Cell>
                      <Button
                        type="button"
                        size="mini"
                        basic
                        color="green"
                        onClick={() => this.editOrder(order, index)}
                        icon
                      >
                        <Icon name="pencil" />
                      </Button>
                    </Table.Cell>
                    <Table.Cell textAlign="right">
                      <Button
                        type="button"
                        size="mini"
                        basic
                        color="red"
                        onClick={() => this.deleteOrder(order, index)}
                        icon
                      >
                        <Icon name="trash" />
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </>
            ) : (
              <Table.Row>
                <Table.Cell colSpan="6" style={{ textAlign: "center" }}>
                  {t("no_record_found") || "No Record(s) Found"}
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
        <ModalEditJobOrder
          size="large"
          mode={this.props.mode}
          values={this.props}
          moment={this.props.moment}
          OpenModel={this.state.openModel}
          handleClose={this.handleModelClose}
          editOrderData={this.state.editOrderData}
          editOrderIndex={this.state.editOrderIndex}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ shipment }) => {
  return { shipment };
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteOrder: (orderIndex) => dispatch(deleteOrderDispatcher(orderIndex)),
    warning: (alert) => dispatch(warningAlertDispatcher(alert)),
    createShipment: (shipment) => dispatch(createShipmentDispatcher(shipment, false)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("order_list")(InsertEditOrder));
